export const throw_ = (e: Error) => {
  throw e;
};
